<template>
  <transition name="upload-progress-fade">
    <div v-if="progress.visible" class="upload-progress-card">
      <div class="upload-progress-title">
        {{ progress.status === 'exception' ? '上传失败' : progress.status === 'success' ? '上传完成' : '正在上传' }}
      </div>
      <div v-if="progress.fileName" class="upload-progress-name">{{ progress.fileName }}</div>
      <el-progress
        :percentage="progress.percent"
        :status="progress.status === 'exception' ? 'exception' : progress.status === 'success' ? 'success' : undefined"
      />
    </div>
  </transition>
</template>

<script>
import uploadProgress from '@/utils/uploadProgress'

export default {
  name: 'GlobalUploadProgress',
  computed: {
    progress() {
      return uploadProgress.state
    },
  },
}
</script>

<style scoped>
.upload-progress-card {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 3000;
  width: 320px;
  padding: 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 12px 32px rgba(31, 35, 41, 0.18);
}

.upload-progress-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.upload-progress-name {
  margin: 8px 0 12px;
  font-size: 12px;
  color: #606266;
  word-break: break-all;
}

.upload-progress-fade-enter-active,
.upload-progress-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.upload-progress-fade-enter,
.upload-progress-fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalUploadProgress.vue